module.exports = __webpack_public_path__ + "f125d1bd487ecd1d151b99a1cd8b1f6a.svg";